<template>
  <div id="editor">
    <!--<toolbar @save="saveData" @change-edge="changeEdge" />-->
    <!--<div style="height: 42px;"/>-->
    <div class="bottom-container">
      <context-menu />
      <div id="itempannel">
        <!--<img draggable="false" data-type="node" data-shape="flow-circle" data-size="72*72" data-color="#FA8C16" class="getItem"
             data-label="开始" data-node-type="1" data-name="开始" data-code="start" src="../../../static/images/ZnPxbVjKYADMYxkTQXRi.svg">-->
        <img draggable="false" data-type="node" data-shape="flow-rect" data-size="80*48" data-color="#1890FF" class="getItem"
             :data-label="defaultLabel" data-node-type="2" data-name="常规" data-code="new node code" src="https://gw.alipayobjects.com/zos/rmsportal/wHcJakkCXDrUUlNkNzSy.svg">
        <!--<img draggable="false" data-type="node" data-shape="flow-rhombus" data-size="80*72" data-color="#13C2C2" class="getItem"-->
             <!--data-label="分叉" data-node-type="3" src="https://gw.alipayobjects.com/zos/rmsportal/SnWIktArriZRWdGCnGfK.svg">-->
        <!--<img draggable="false" data-type="node" data-shape="flow-circle" data-size="72*72" data-color="#FA8C16" class="getItem"
             data-label="结束" data-node-type="4" data-name="结束" data-code="end" src="../../../static/images/ZnPxbVjKYADMYxkTQXRi2.svg">-->
        <!--<navigator :cur-zoom="curZoom" :min-zoom="minZoom" :max-zoom="maxZoom" @change-zoom = "changeZoom" />-->
      </div>
      <!--<div id="detailpannel">
        <div id="node_detailpannel" data-status="node-selected" class="pannel">
          <div class="pannel-title">节点</div>
          <div class="block-container">
            <el-form label-width="60px">
              <el-form-item label="节点名称" prop="label">
                <el-input v-model="inputingLabel" clearable size="mini"/>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div
          id="edge_detailpannel" data-status="edge-selected" class="pannel">
          <div class="pannel-title">边</div>
          <div class="block-container">
            <el-form label-width="60px">
              <el-form-item label="名称" prop="label">
                <el-input v-model="inputingLabel" clearable size="mini"/>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div
          id="canvas_detailpannel" data-status="canvas-selected" class="pannel">
          <div class="pannel-title">画布</div>
          <div class="block-container">
            <el-checkbox @change="toggleGrid">网格对齐</el-checkbox>
          </div>
        </div>
        <div
          id="multi_detailpannel" data-status="multi-selected" class="pannel">
          <div class="pannel-title">多选</div>
          <div class="block-container">
            暂无设置
          </div>
        </div>
        <div
          id="group_detailpannel" data-status="group-selected" class="pannel">
          <div class="pannel-title">群组名称</div>
          <div class="block-container">
            <el-input v-model="inputingLabel"/>
          </div>
        </div>
      </div>-->
      <page />
    </div>
  </div>
</template>

<script>
import Navigator from '@/components/g6/navigator'
import Toolbar from '@/components/g6/toolbar'
import ContextMenu from '@/components/g6/context-menu'
import Page from '@/components/g6/page'
import Editor from '@/components/g6/editor'

export default {
  components: {
    Navigator,
    Toolbar,
    ContextMenu,
    Page
  },
  extends: Editor,
  props: {
    flowData: String
  },
  data () {
    return {
      defaultLabel: 'new node code\n常规',
      tempFlowData: null,
      tempInputingLabel: null
    }
  },
  watch: {
    flowData (val, oldVal) {
      this.initData()
    }
  },
  computed: {
    inputingLabel: {
      get () {
        return this.tempInputingLabel !== null ? this.tempInputingLabel : this.selectedModel.label
      },
      set (value) {
        if (value) {
          this.updateGraph('label', value)
        }
        this.tempInputingLabel = null
      }
    }
  },
  mounted () {
    this.changeEdge('flow-smooth')
    this.initData()
  },
  methods: {
    saveData () {
      const json = JSON.stringify(this.page.save())
      console.info('flow-editor:saveData', json)
      this.$emit('saveData', json)
    },
    initData () {
      if (!this.flowData) return
      this.tempFlowData = JSON.parse(this.flowData)
      this.page.read(this.tempFlowData)
    }
  }
}
</script>
<style lang="scss">
  #itempannel{
    height: 100%;
    position: absolute;
    left: 0px;
    z-index: 2;
    background: #F7F9FB;
    width: 200px;
    padding-top: 8px;
    border-right: 1px solid #E6E9ED;
  }
  #itempannel img{
    width: 92px;
    height: 96px;
    padding: 4px;
    margin-left: 4px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0);
  }
  #itempannel img:hover{
    cursor: move;
    border: 1px solid #ccc;
  }
  #detailpannel{
    height: 100%;
    position: absolute;
    right: 0px;
    z-index: 2;
    background: #F7F9FB;
    width: 200px;
    border-left: 1px solid #E6E9ED;
  }
  #detailpannel .pannel{
    display: none
  }
  #detailpannel .block-containe{
    padding-top: 20px;
  }
  #detailpannel .input{
    margin-left: 16px;
  }
  #detailpannel .name-input{
    width: 120px;
  }
  #detailpannel .width-input{
    width: 52px;
  }
  #detailpannel .height-input{
    width: 52px;
  }
  #detailpannel .block-container{
    padding: 16px 8px;
  }
  .bottom-container{
    position: relative;
  }
  .pannel-title{
    height: 32px;
    border-top: 1px solid #DCE3E8;
    border-bottom: 1px solid #DCE3E8;
    background: #EBEEF2;
    color: #000;
    line-height: 28px;
    padding-left: 12px;
  }
  .zoom-dropdown-btn {
    color: rgba(0,0,0,0.45);
    margin-left: 4px;
    line-height: 24px;
    font-weight: 100;
    text-decoration : none;
  }
  .color-picker{
    vertical-align: middle;
    margin-left: 16px;
  }
  .p{
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/g6/flow-editor.vue